"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintOption = void 0;
const react_1 = __importStar(require("react"));
const forms_1 = require("../../forms");
const PrintOption_styles_1 = require("./PrintOption.styles");
const PrintOption = (props) => {
    const { active, description, printOptions, setPrintOptionSelectValue } = props;
    const [printOption, setPrintOption] = (0, react_1.useState)(printOptions && printOptions[0].value ? printOptions[0].value : "");
    return (react_1.default.createElement(PrintOption_styles_1.Wrapper, { active: active },
        react_1.default.createElement(PrintOption_styles_1.Description, null, description),
        printOptions && (react_1.default.createElement(PrintOption_styles_1.SelectInputFieldWrapper, null,
            react_1.default.createElement(forms_1.SelectInputField, { value: printOption, options: printOptions, onChange: (value) => {
                    setPrintOption(value);
                    setPrintOptionSelectValue(value);
                }, label: "" })))));
};
exports.PrintOption = PrintOption;
exports.default = exports.PrintOption;
//# sourceMappingURL=PrintOption.js.map